import React from 'react';
import { Box, Container, Grid } from '@drivekyte/web-components';
import { useMedia } from '@drivekyte/ui';
import Image from 'next/image';
import styled from 'styled-components';
import AsFeaturedIn from '@/components/growth/as-featured-in';
import Search from '@/components/growth/search';
import { CustomSearchType } from './types';

type SearchSectionProps = {
  city?: string;
  bg?: string;
  custom?: CustomSearchType;
  title?: string;
  subTitle?: string;
  lightText?: boolean;
};

const SearchSection = ({
  city,
  bg,
  custom,
  title,
  subTitle,
  lightText,
}: SearchSectionProps) => {
  const media = useMedia();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      {media.sm ? (
        <Grid container direction="row">
          <Grid item xs={12}>
            <SearchContainerMobile>
              <Search
                city={city}
                custom={custom}
                title={
                  custom === 'road-trips-in-state' || custom === 'road-trips'
                    ? title
                    : undefined
                }
                subTitle={
                  custom === 'road-trips-in-state' ? subTitle : undefined
                }
              />
            </SearchContainerMobile>
          </Grid>
        </Grid>
      ) : (
        <Box position="relative" height="100%" width="100%">
          <Box
            position="absolute"
            height="100%"
            width="100%"
            zIndex={-1}
            overflow="hidden"
          >
            <Image
              src={`/images/backgrounds/${bg}.webp`}
              fill
              priority
              quality={50}
              alt=""
            />
          </Box>
          <Container>
            <SearchContainer>
              <Search
                city={city}
                custom={custom}
                lightText={lightText}
                title={title}
                subTitle={subTitle}
              />
            </SearchContainer>
          </Container>
        </Box>
      )}
      <AsFeaturedIn />
    </Box>
  );
};

const SearchContainer = styled.div`
  padding-top: 114px;
  padding-bottom: 158px;
  width: 100%;
`;

const SearchContainerMobile = styled.div`
  padding-left: ${({ theme }) => theme.spacings.small}px;
  padding-right: ${({ theme }) => theme.spacings.small}px;
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export default SearchSection;
